var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "35px",
    viewBox: "0 0 38 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E3497EF8-C7DC-4DF7-B5FB-3B6A82C581C5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legal-statements-svg-icons",
    transform: "translate(-77.000000, -248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-93",
    transform: "translate(78.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,33 C11.7059207,32.1077941 12.1851441,31.1347426 12.4376701,30.0808456 C12.6901962,29.0269485 12.6901962,28.3333333 12.4376701,28 L23.5623299,28 C23.3227182,28.3872304 23.3227182,29.0808456 23.5623299,30.0808456 C23.8019415,31.0808456 24.2811649,32.053897 25,33 L11,33 Z",
    id: "Path",
    stroke: "#788999",
    fill: "#C5CCD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#788999",
    fillRule: "nonzero",
    points: "12.2259849 30 12.2259849 28 23.8097019 28 23.8097019 30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#788999",
    x: 7,
    y: 33,
    width: 22,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#788999",
    fill: "#E7EAF3",
    x: 0,
    y: 0,
    width: 36,
    height: 28,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#FFFFFF",
    x: 0.5,
    y: 4,
    width: 35,
    height: 19
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#788999",
    cx: 18,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3460589,17.250212 C23.4313229,18.3382401 22.7161535,18.7613621 22.2005507,18.5195781 C21.6849479,18.2777941 21.8279818,16.9019808 22.6296523,14.3921383 C24.1931265,9.50564194 24.9829513,6.94394626 24.9991266,6.70705126 C25.0233896,6.35170876 24.5391564,5.79266177 23.9169573,6.07874099 C23.5021578,6.26946047 23.2160901,6.47889723 23.058754,6.70705126 L21.1536558,12.2927596 L17.6421204,12.2927596 L19.2127319,7.334623 C19.430466,6.8152022 19.430466,6.48971232 19.2127319,6.35815338 C18.8861306,6.16081495 15.8389739,6.16526123 13.8743104,7.59863152 C11.9096469,9.03200181 10.7886776,11.3093922 11.7457886,12.5956475 C12.7028997,13.8819029 14.7753905,12.5230629 14.7677712,12.1444888 C14.7601519,11.7659147 12.6771468,11.3127256 13.7074725,9.60001474 C14.3943563,8.45820752 15.5237591,7.70458 17.0956809,7.33913217 C15.6477341,12.2180061 14.7323706,15.1845055 14.3495904,16.2386304 C13.77542,17.8198176 13.1487304,19.2003172 12.4713371,19.0719799 C11.7939438,18.9436427 12.8214478,17.2197668 12.4713371,16.7704219 C12.1212264,16.3210769 10.7376844,18.010118 11.043908,19.0719799 C11.2480571,19.7798879 11.8201926,20.0724329 12.7603146,19.9496149 C13.8154332,19.746943 14.6755799,19.1587797 15.3407547,18.185125 C16.0059295,17.2114703 16.6822425,15.5865395 17.3696939,13.3103326 L20.9132458,13.3103326 L20.0550425,16.2386304 C19.6785703,18.4560209 19.9646381,19.6930157 20.9132458,19.9496149 C21.8618534,20.2062141 23.0061245,19.482714 24.3460589,17.7791145 L24.3460589,17.250212 Z",
    id: "Path-2-Copy",
    fill: "#788999",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 3.5,
    x2: 35.5,
    y2: 3.5,
    id: "Line-36",
    stroke: "#788999",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 22.5,
    x2: 35.5,
    y2: 22.5,
    id: "Line-36",
    stroke: "#788999",
    strokeLinecap: "square"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenIcon);
export default __webpack_public_path__ + "static/media/screenIcon.66d918ebabc4d2a93efe8ba3f8ee5eea.svg";
export { ForwardRef as ReactComponent };